import React from 'react'
import { useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'
import NormalLayoutContainer from '../shared/NormalLayoutContainer'
import notify from '../../utilities/notify'
import { handleValidateAndNotify } from '../../utilities/errorHandlers'
import useMutation from '../../hooks/useMutation'
import createTermsAndConditionMutation from '../../graphql/mutations/createTermsAndCondition'
import { ROUTES } from '../../routes'
import { mapFormToInput } from './utils'
import CreateTermsAndConditionAgreementForm from './CreateTermsAndConditionAgreementForm'

export default function CreateTermsAndConditionAgreementPage () {
  const history = useHistory()
  const { user } = useSelector(({ user }) => ({ user: user.user }))

  const { mutate: createTermsAndCondition, isLoading: isSaving } = useMutation(createTermsAndConditionMutation, {
    onSuccess (_data, variables) {
      const isDraft = !variables.input.publish
      notify('success', isDraft ? 'Agreement saved as draft' : 'Agreement published successfully')
      history.push(ROUTES.termsAndConditionsAgreements)
    },
    onError (error) {
      handleValidateAndNotify(error, 'Failed to create T&C agreement')
    }
  })

  function saveAgreement (values, publish) {
    createTermsAndCondition({
      haulerId: user.haulerId,
      input: mapFormToInput(values, publish)
    })
  }

  return (
    <NormalLayoutContainer showBackLink>
      <CreateTermsAndConditionAgreementForm
        onSubmit={saveAgreement}
        isSaving={isSaving}
      />
    </NormalLayoutContainer>
  )
}
